import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NProgress } from 'redux-nprogress';
import 'nprogress/nprogress.css';
import debug from 'debug';
// import { redirect } from 'redux-first-router';

import Layout from './Layout';
import Home from './views/Home';
import Season from './views/Season';
import WeeklyStats from './views/WeeklyStats';
import Login from './views/Login';
import Logout from './views/Logout';
import EmailPreferences from './views/EmailPreferences';
import PlayerProjections from './views/PlayerProjections';
import Predictions from './views/Predictions';
import MatchupAnalysis from './views/Predictions/MatchupAnalysis';
import TeamPositionRankings from './views/TeamPositionRankings';
import CheatSheets from './views/CheatSheets';
import Print from './views/Print';
import PrintProjections from './views/PrintProjections';
import Dynasty from './views/Dynasty';
import Auction10 from './views/Auction10';
import Auction12 from './views/Auction12';
import Top200 from './views/Top200';
import Top200PPR from './views/Top200PPR';
import Top200QB from './views/Top200QB';
import BoxScores from './views/BoxScores';
import StartBench from './views/StartBench';
import WaiverWire from './views/WaiverWire';
import ConnectedContentGate from './components/ContentGate/ContentGate';
import PlayerTracking from './views/PlayerTracking';
import AccountInformation from './views/AccountInfo';
import TeamsLanding from './views/TeamsLanding';
import Player from './views/Player';
import Team from './views/Team';
import News from './views/News';
import DepthCharts from './views/DepthCharts';
import SubscribeForm from './views/Subscribe/SubscribeForm';
import StrengthOfSchedule from './views/StrengthOfSchedule/';
import TeamPositionRanksMatchups from './views/TeamPositionRanksMatchups';
import PaymentInformation from './views/PaymentInformation';
import RenewSubscription from './views/PaymentInformation/RenewSubscription';
import GameStatsMatchups from './views/GameStatsMatchups/GameStatsMatchups';
import RequestPassword from './views/PasswordRequest/';
import RequestPassword2 from './views/PasswordForceRequest/';
import ResetPassword from './views/PasswordReset/';
import RequestUsername from './views/UsernameRequest/';
import LearnMore from './views/LearnMore';
import NFLSchedule from './views/NFLSchedule/NFLSchedule';
import NotFound from './views/NotFound';

// myHuddle views
import MyHuddleContainer from './Layout/MyHuddleLayout';
import Custom from './views/Custom';
import CustomCreate from './views/Custom/Create';
import CustomEdit from './views/Custom/Edit';
import CustomDuplicate from './views/Custom/Duplicate';
import LeagueDetails from './views/Custom/Details';
import HuddleSearch from './views/HuddleSearch';

// TODO remove completely once we've implemented all these
import AktaryTechPlaceholderComponent from './views/AktaryTechPlaceholderComponent';

import classes from './App.css';
import '../assets/css/style.css';

const log = debug('huddle:app:app');

const progressColor = '#dd9933';

const selectView = (view, subView) => {
  if (!view) {
    return null;
  }
  switch (view) {
    case 'Home': return <Home />;
    case 'Season': return <Season />;
    case 'WeeklyStats': return <WeeklyStats />;
    case 'PlayerProjections': return <PlayerProjections />;
    case 'Predictions': return <Predictions />;
    case 'MatchupAnalysis': return <MatchupAnalysis />;
    case 'TeamPositionRankings': return <TeamPositionRankings />;
    case 'Login': return <Login />;
    case 'Logout': return <Logout />;
    case 'CheatSheets': return <CheatSheets />;
    case 'Dynasty': return <Dynasty />;
    case 'Print': return <Print />;
    case 'PrintProjections': return <PrintProjections />;
    case 'Auction10': return <Auction10 />;
    case 'Auction12': return <Auction12 />;
    case 'Top200': return <Top200 />;
    case 'Top200PPR': return <Top200PPR />;
    case 'Top200QB': return <Top200QB />;
    case 'GameStatsMatchups': return <GameStatsMatchups />;
    case 'BoxScores': return <BoxScores />;
    case 'PlayerLanding': return <HuddleSearch />;
    case 'StartBench': return <StartBench />;
    case 'WaiverWire': return <WaiverWire />;
    case 'Subscribe':
      return <SubscribeForm />;
    case 'TeamsLanding': return <TeamsLanding />;
    case 'Player': return <Player />;
    case 'Team': return <Team />;
    case 'News': return <News />;
    case 'DepthCharts': return <DepthCharts />;
    case 'StrengthOfSchedule': return <StrengthOfSchedule />;
    case 'TeamRanksMatchups': return <TeamPositionRanksMatchups />;
    case 'RequestPassword': return <RequestPassword />;
    case 'RequestPassword2': return <RequestPassword2 />;
    case 'ResetPassword': return <ResetPassword />;
    case 'RequestUsername': return <RequestUsername />;
    case 'LearnMore': return <LearnMore />;
    case 'LeagueDetails': return <LeagueDetails />;
    case 'NFLSchedule': return <NFLSchedule />;
    case 'myhuddle': return (
      <MyHuddleContainer>
        { subView === 'Custom' && <Custom /> }
        { subView === 'CustomCreate' && <CustomCreate /> }
        { subView === 'CustomEdit' && <CustomEdit /> }
        { subView === 'CustomDuplicate' && <CustomDuplicate /> }
        { subView === 'LeagueDetails' && <LeagueDetails /> }
        { subView === 'EmailPreferences' && <EmailPreferences /> }
        { subView === 'HuddleSearch' && <HuddleSearch /> }
        { subView === 'PlayerTracking' && <PlayerTracking /> }
        { subView === 'AccountInformation' && <AccountInformation /> }
        { subView === 'ChangePassword' && <AccountInformation /> }
        { subView === 'PaymentInformation' && <PaymentInformation /> }
        { subView === 'RenewSubscription' && <RenewSubscription /> }
        {
          !['Custom', 'CustomCreate', 'CustomEdit', 'CustomDuplicate',
            'EmailPreferences', 'HuddleSearch', 'LeagueDetails', 'PlayerTracking',
            'AccountInformation', 'PaymentInformation', 'RenewSubscription', 'ChangePassword']
            .includes(subView) && <AktaryTechPlaceholderComponent title={subView} />
        }
      </MyHuddleContainer>
    );
    case 'NotFound': return <NotFound />;
    default: return <AktaryTechPlaceholderComponent title={view} />;
  }
};

const mapStateToProps = state => ({
  view: state.currentView,
  loggedIn: state.auth.loggedIn,
  accountStatus: state.auth.user ? state.auth.user.status : '',
});

class App extends PureComponent {
  static propTypes = {
    view: PropTypes.string.isRequired,
    loggedIn: PropTypes.bool.isRequired,
  }

  state = {
    hasStatus: false,
  }

  componentWillReceiveProps(nextProps) {
    /* Hacks: initial page load fails, should refresh it if loading a new view */
    /* if (nextProps.view !== this.props.view && nextProps.view === 'PlayerProjections') {
      window.location.reload();
    } */
  }

  checkUserStatus = () => {
    let temp = true;

    if (typeof document !== undefined) {
      if (!this.props.loggedIn && location.href.toLowerCase().indexOf('login') === -1 ) {
        location.href = '/login';
        temp = false;
      }
      if (location.href === 'https://tools.thehuddle.com/' || location.href === 'https://www.tools.thehuddle.com/' || location.href === 'https://www.tools.thehuddle.com' || location.href === 'https://tools.thehuddle.com') {
        location.href = 'http://thehuddle.com/';
        temp = false;
      }
      // not sure if this is still needed, but it's not doing any harm
      if (location.href === 'https://tools.thehuddle.com/draft_kit/player_projections') {
        location.href = 'https://tools.thehuddle.com/fantasy-football-projections'
        temp = false;
      }
    }
    temp && this.setState({hasStatus: true});
  }

  render() {
    const [view, ...subViews] = this.props.view.split('/');
    const subView = subViews.pop();
    const { loggedIn, accountStatus } = this.props;
    const isExpired = !(accountStatus === 'A' || !accountStatus);
    const that = this;
    const isPrintPage = (view === 'Print' || view === 'PrintProjections');
    if (view === 'NotFound' || view === 'LearnMore') {
      return (
        <div className={classes.body}>
          <Layout isPrintPage={isPrintPage}>
            {selectView(view, subView)}
          </Layout>
        </div>
      );
    }
    if (!loggedIn) {
      return (
        <div className={classes.body}>
          <Layout isPrintPage={isPrintPage}>
            <ConnectedContentGate loggedIn={loggedIn} isExpired={isExpired} >
              {selectView(view, subView)}
            </ConnectedContentGate>
          </Layout>
        </div>
      );
    }
    return (
      <div className={!this.state.hasStatus ? classes.noStatusBody : classes.body}>
        {typeof window !== 'undefined' && that.checkUserStatus()}
        {loggedIn && <NProgress color={progressColor} />}
        {loggedIn && <Layout isPrintPage={isPrintPage}>
          <ConnectedContentGate loggedIn={loggedIn} isExpired={isExpired} >
            {selectView(view, subView)}
          </ConnectedContentGate>
        </Layout>}
      </div>
    );
  }
}
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/app/App.js